<template>
 <svg :style="style" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Frame" clip-path="url(#clip0_3654_78152)">
<path id="Vector" d="M19 8.125H15.5V5.5C15.4993 4.57196 15.1303 3.68215 14.4741 3.02593C13.8179 2.36971 12.928 2.00072 12 2H5C4.07196 2.00072 3.18215 2.36971 2.52593 3.02593C1.86971 3.68215 1.50072 4.57196 1.5 5.5V19.5C1.50072 20.428 1.86971 21.3179 2.52593 21.9741C3.18215 22.6303 4.07196 22.9993 5 23H19C19.928 22.9993 20.8179 22.6303 21.4741 21.9741C22.1303 21.3179 22.4993 20.428 22.5 19.5V11.625C22.4993 10.697 22.1303 9.80715 21.4741 9.15093C20.8179 8.49471 19.928 8.12572 19 8.125ZM5.875 21.25V15.125C5.87572 14.6611 6.06033 14.2164 6.38836 13.8884C6.71639 13.5603 7.16109 13.3757 7.625 13.375H9.375C9.83891 13.3757 10.2836 13.5603 10.6116 13.8884C10.9397 14.2164 11.1243 14.6611 11.125 15.125V21.25H5.875ZM6.75 9C6.51794 9 6.29538 8.90781 6.13128 8.74372C5.96719 8.57962 5.875 8.35706 5.875 8.125C5.875 7.89294 5.96719 7.67038 6.13128 7.50628C6.29538 7.34219 6.51794 7.25 6.75 7.25H7.625V6.375C7.625 6.14294 7.71719 5.92038 7.88128 5.75628C8.04538 5.59219 8.26794 5.5 8.5 5.5C8.73206 5.5 8.95462 5.59219 9.11872 5.75628C9.28281 5.92038 9.375 6.14294 9.375 6.375V7.25H10.25C10.4821 7.25 10.7046 7.34219 10.8687 7.50628C11.0328 7.67038 11.125 7.89294 11.125 8.125C11.125 8.35706 11.0328 8.57962 10.8687 8.74372C10.7046 8.90781 10.4821 9 10.25 9H9.375V9.875C9.375 10.1071 9.28281 10.3296 9.11872 10.4937C8.95462 10.6578 8.73206 10.75 8.5 10.75C8.26794 10.75 8.04538 10.6578 7.88128 10.4937C7.71719 10.3296 7.625 10.1071 7.625 9.875V9H6.75ZM17.6875 18.625C17.4554 18.625 17.2329 18.5328 17.0688 18.3687C16.9047 18.2046 16.8125 17.9821 16.8125 17.75C16.8125 17.5179 16.9047 17.2954 17.0688 17.1313C17.2329 16.9672 17.4554 16.875 17.6875 16.875H18.5625C18.7946 16.875 19.0171 16.9672 19.1812 17.1313C19.3453 17.2954 19.4375 17.5179 19.4375 17.75C19.4375 17.9821 19.3453 18.2046 19.1812 18.3687C19.0171 18.5328 18.7946 18.625 18.5625 18.625H17.6875ZM18.5625 14.25H17.6875C17.4554 14.25 17.2329 14.1578 17.0688 13.9937C16.9047 13.8296 16.8125 13.6071 16.8125 13.375C16.8125 13.1429 16.9047 12.9204 17.0688 12.7563C17.2329 12.5922 17.4554 12.5 17.6875 12.5H18.5625C18.7946 12.5 19.0171 12.5922 19.1812 12.7563C19.3453 12.9204 19.4375 13.1429 19.4375 13.375C19.4375 13.6071 19.3453 13.8296 19.1812 13.9937C19.0171 14.1578 18.7946 14.25 18.5625 14.25Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_3654_78152">
<rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>





</template>

<script>
export default {
  name: 'icon-in-hospital',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>